import childHeroImage from "@/assets/child-hero.jpg";

const PersonalizationDemo = () => {
  return (
    <section className="py-16 md:py-24 px-4 bg-gradient-to-b from-background to-[hsl(var(--playful-purple),0.05)]">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Left - Image */}
          <div className="relative flex justify-center">
            <div className="relative max-w-[70%]">
              <div className="absolute inset-0 bg-gradient-to-br from-[hsl(var(--playful-pink),0.3)] to-[hsl(var(--playful-purple),0.3)] rounded-3xl blur-2xl" />
              <div className="relative rounded-3xl overflow-hidden shadow-2xl border-2 border-[hsl(var(--playful-pink),0.2)]">
                <img 
                  src={childHeroImage} 
                  alt="Child imagining themselves as a hero" 
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>
          
          {/* Right - Text Content */}
          <div className="text-center md:text-left space-y-6">
            <span className="inline-block px-4 py-1 bg-[hsl(var(--playful-pink),0.2)] text-[hsl(var(--playful-pink))] rounded-full text-sm font-medium">
              ✨ Personalized Stories
            </span>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground leading-tight">
              Make your child the{" "}
              <span className="bg-gradient-to-r from-[hsl(var(--playful-orange))] to-[hsl(var(--playful-pink))] bg-clip-text text-transparent">
                hero
              </span>{" "}
              of their stories
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed">
              Every story features your child's name as the main character, making bedtime magical and personal. Watch their eyes light up when they hear adventures crafted just for them.
            </p>
            <ul className="space-y-3 text-left">
              {[
                "Your child's name woven into every tale",
                "Stories tailored to their age and interests",
                "Lessons that resonate and stick"
              ].map((item, index) => (
                <li key={index} className="flex items-center gap-3 text-foreground">
                  <span className="w-6 h-6 rounded-full bg-gradient-to-br from-[hsl(var(--playful-teal))] to-[hsl(var(--playful-purple))] flex items-center justify-center text-white text-xs">
                    ✓
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PersonalizationDemo;
